import React, { useState, useEffect } from "react";

import { Button, Form } from "reactstrap";
import Spinner from "react-bootstrap/Spinner";
import { Header_panel } from "../Useful/Useful";
import {
  DateTimeInput,
  DateTimeInputSimple,
  DateInput,
  DateInputSimple,
} from "react-hichestan-datetimepicker";

import "../Useful/useful.css";
import { NewsGetById, NewsUploadFile, ProvincegGet } from "../../fetch";

export default function AddNews(props) {
  const [ison, setison] = useState(false);
  const [ImgUrl, setImgUrl] = useState("");
  const [provinces, setprovinces] = useState([]);
  const [provinceId, setprovinceId] = useState("");
  const [setting, setSetting] = useState({
    title: "",
    desc: "",
    dateTime: "",
    imgUrl: "",

    slider: "",
  });
  const { title, desc, slider, dateTime } = setting;
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    NewsGetById(props.id)
      .then((response) => {
        setLoading(false);

        return response.json();
      })
      .then((responseJson) => {
        setImgUrl(responseJson.imgUrl);
        setison(responseJson.slider);
        setprovinceId(responseJson.townId);
        setSetting({
          desc: responseJson.desc,
          title: responseJson.title,
          dateTime: responseJson.dateTime,

          slider: responseJson.slider,
          // imgUrl: responseJson.imgUrl,
        });
      })
      .catch((error) => {
        setLoading(false);
        console.log(error);
      });

    var htmlInput1 = document.getElementById("title");
    htmlInput1.oninvalid = function (e) {
      e.target.setCustomValidity("لطفا عنوان را وارد کنید");
      htmlInput1.oninput = function (e) {
        e.target.setCustomValidity("");
      };
    };
  }, [props.id]);

  useEffect(() => {
    ProvincegGet(0, 999)
      .then((response) => {
        // setLoading(false);

        return response.json();
      })
      .then((responseJson) => {
        setprovinces(responseJson.result);
      })
      .catch((error) => {
        setLoading(false);
        console.log(error);
      });
  }, []);
  const onSubmit = (e) => {
    e.preventDefault();

    var Data = {
      id: props.id,
      dateTime: dateTime,
      title: e.target.title.value,
      desc: e.target.desc.value,
      ImgUrl: ImgUrl,
      NewsTypeId: 201,
      ProvinceId: provinceId,
      Slider: e.target.ison.checked,
    };
    var Data1 = {
      dateTime: dateTime,
      title: e.target.title.value,
      desc: e.target.desc.value,
      ImgUrl: ImgUrl,
      NewsTypeId: 201,
      ProvinceId: provinceId,
      Slider: e.target.ison.checked,
    };
    if (props.id) {
      props.onFormSubmit(Data);
    } else {
      props.onFormSubmit(Data1);
    }
    setison(false);
    setSetting({
      categoryPost_CategoryId: "",
      desc: "",
      title: "",
      ImgUrl: "",
    });
  };

  const handleChange = (name) => (event) => {
    const target = event.target;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const name = target.name;
    event.persist();
    setSetting((prevState) => ({ ...prevState, [name]: value }));
  };

  const handleSelectFile = (event) => {
    setLoading(true);
    NewsUploadFile(event.target.files[0])
      .then((response) => {
        setLoading(false);
        return response.json();
      })
      .then((responseJson) => {
        setImgUrl(responseJson.pathFName);
      })
      .catch((error) => {
        setLoading(false);
        console.error(error);
      });
  };
  const handleCheckChange = (name) => (event) => {
    setison(event.target.checked);
  };

  return (
    //add item
    <div className="col-lg-12 mypanel shadow">
      <Header_panel title="افزودن اطلاعیه ها" idMenu={props.navid} />
      <div className="pos-f-t">
        <div className="collapse" id="navbarToggleExternalContentSettingAdd1">
          <Form onSubmit={onSubmit}>
            <div className="row p-4">
              <div className="col-lg-6">
                <div className="form-group textg">
                  <label className="control-label" htmlFor="title">
                    * عنوان{" "}
                  </label>
                  <input
                    required
                    // ref={this.fileInput}
                    value={title}
                    id="title"
                    onChange={handleChange("title")}
                    className="contactInput form-control"
                    name="title"
                    placeholder="عنوان..."
                  />
                </div>
              </div>

              {/* <div className="col-lg-4">
                <div className="form-group textg">
                  <label
                    className="control-label"
                    htmlFor="categoryPost_CategoryId"
                  >
                    دسته بندی{" "}
                  </label>
                  <select
                    className="form-control"
                    name="categoryPost_CategoryId"
                    id="categoryPost_CategoryId"
                    value={categoryPost_CategoryId}
                    onChange={handleChange("categoryPost_CategoryId")}
                  >
                    {props.category.map((cat) => (
                      <option key={cat.id} value={cat.id}>
                        {cat.name}
                      </option>
                    ))}
                  </select>
                </div>
              </div> */}

              <div className="col-lg-12 ">
                <div className="form-group textg ">
                  <label className="control-label" htmlFor="image">
                    انتخاب فایل
                  </label>
                  <div className="custom-file">
                    <input
                      type="file"
                      accept="image/*"
                      className="custom-file-input"
                      id="image"
                      aria-describedby="inputGroupFileAddon01"
                      onChange={handleSelectFile}
                    />
                    <div
                      className="custom-file-label "
                      value={ImgUrl}
                      htmlFor="inputGroupFile01"
                    >
                      <span className="pad"> آدرس تصویر &larr; {ImgUrl}</span>
                    </div>
                  </div>
                </div>
              </div>
              {ImgUrl && (
                <div className="col  mb-5 ">
                  <div className=" m-2  ">
                    <img
                      width={150}
                      height={150}
                      // value={item.url}
                      src={`https://macks-b.ir/${ImgUrl}`}
                      alt={""}
                    />
                  </div>
                </div>
              )}

              <div className="col-lg-12">
                <div className="form-group textg">
                  <label className="control-label" htmlFor="first_name">
                    توضیحات
                  </label>
                  <textarea
                    rows="2"
                    value={desc}
                    id="desc"
                    onChange={handleChange("desc")}
                    className="contactInput form-control"
                    name="desc"
                    placeholder="متن..."
                  />
                </div>
              </div>
              <div className="  margin form-group textg col-lg-2  form-control ">
                <input
                  id="ison"
                  value="ison"
                  name="ison"
                  type="checkbox"
                  onChange={handleCheckChange("ison")}
                  checked={ison}
                />
                <label className="control-label" htmlFor="ison">
                  اسلایدر
                </label>
              </div>
              <div className="col-lg-4">
                <div class="textg">
                  <label className="control-label" htmlFor="dateTime">
                    تاریخ
                  </label>

                  <DateTimeInput
                    // filterDate={true}
                    id="dateTime"
                    name="dateTime"
                    className="form-control"
                    value={dateTime}
                    onChange={(e) => setSetting({ dateTime: e.target.value })}
                    placeholder=" تاریخ ..."
                  />
                </div>
              </div>
              <div className="form-group textg  col-lg-3">
                <label className="control-label" htmlFor="provinceId">
                  * استان{" "}
                </label>
                <select
                  className="form-control"
                  required
                  name="provinceId"
                  id="provinceId"
                  value={provinceId}
                  onChange={(e) => setprovinceId(e.target.value)}
                >
                  <option value="">---</option>
                  {provinces.map((cat, index) => (
                    <option key={cat.id} value={cat.id}>
                      {cat.name}
                    </option>
                  ))}
                  ))
                </select>
              </div>
            </div>
            {loading && (
              <Spinner
                className="buttonProgress"
                animation="border"
                variant="primary"
              />
            )}
            <Button type="submit" color="primary" id="regProdbtn">
              ذخیره
            </Button>
          </Form>
        </div>
      </div>
    </div>
  );
}
